module.exports = __webpack_public_path__ + "static/media/meyers.cacabdc1.png";